import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-epp',
  templateUrl: './identity-mgt-epp.component.html',
  styleUrls: ['./identity-mgt-epp.component.scss']
})
export class IdentityMgtEppComponent implements OnInit {
  public type = '';
  public selected = '';
  public lastname = '';
  public uid = '';
  public pasteData = '';
  public pasteInd = 'N';
  public userId: string;
  public pwd: string;
  public email: string;
  error: boolean;
  message: any;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public showPlaceholder: boolean;
  public isLoading = false;
  public validate = true;
  public errorFields: any = {
    uid: false,
    lastname: false
  };
  constructor(private router: Router,private forgotService: ForgotService, private appInsightsService: AppInsightsService) {}
  
  @ViewChild('user') public user: ElementRef;
  @ViewChild('last') public last: ElementRef;
  
  focusOnInput() {
    let setError = false;
    if (!!this.errorFields.uid) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.errorFields.lastname) {
      setError = true;
      setTimeout(() => this.last.nativeElement.focus(), 0);
      setTimeout(() => this.last.nativeElement.select(), 0);
      window.scrollTo(0,this.last.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.errorFields.uid && !this.errorFields.lastname) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['uid', 'lastname'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateFields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }
  
  validateFields(model) {
    let error = false;
    this.validate = true;
    if (model === 'uid') {
      if (!this.uid) {
        this.errorFields.uid = true;
        error = true;
      } else {
        this.errorFields.uid = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
   if (model === 'lastname') {
    if (!this.lastname) {
      this.errorFields.lastname = true;
      error = true;
    } else {
      this.errorFields.lastname = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }

    if (!!this.uid && !!this.lastname && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  
  
  ngOnInit() {
    console.log('epp loaded');
    window.scroll(0,0);
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Forgot UI Page - EPP");
    this.forgotService.getUid().subscribe( res => {
      this.userId = res;
      if (this.userId) {
        this.showId = true;
      }
    });
    this.forgotService.getType().subscribe( res => {
      this.pwd = res;
      if (this.pwd === 'pwd') {
        this.showpwd = true;
      }
    });
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  continue() {
      const userType = 'epp';
      const userId = this.uid;
      const lastName = this.lastname;
      const json = JSON.stringify({ userId, lastName , userType});
      if (!this.validateAllFields()) {
        setTimeout(() => {
          window.scroll(0,0);
          this.error = false;
          this.isLoading = true;
          this.validate = true;
        });
        this.forgotService.getPassword(json).subscribe( res => {
          this.forgot =  res;
          if (this.forgot) {           
            if (this.forgot.status_code && this.forgot.status_code !== '200') {
            	setTimeout(() => {
	              this.isLoading = false;
	            });
                this.message = this.forgot.message;
                this.error = true;
                this.validate = false;
                window.scroll(0,0);
              } else {
                  this.error = false;
                  this.forgotService.setQuestions(this.forgot.questions);
                  this.forgotService.setType('pwd');
                  this.forgotService.setUserType(userType);
                  this.router.navigate(['/questions']);
              }
          }
        });
      } else {
      	this.focusOnInput();
      }
  }


  back() {
    this.router.navigate(['']);
  }

    paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }
}
